module.exports = __webpack_public_path__ + "static/___007___Exclusive-privileges-from-Banyan-Tree-Group-worldwide-.9c10bb4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/___007___Exclusive-privileges-from-Banyan-Tree-Group-worldwide-.jpg
// module id = 1283
// module chunks = 64098118039141